<div class="layout">
	<slot />
</div>

<style>
	:global(:root) {
		--grey-color: #3a3a3a;
	}
	:global(body) {
		margin: 0px;
		padding: 0px;
	}
	:global(*) {
		margin: 0px;
		padding: 0px;
		user-select: none;
        -o-user-select:none;
        -moz-user-select: none;
        -khtml-user-select: none;
       -webkit-user-select: none;
		font-family: Arial, Helvetica, sans-serif;
	}
	div {
		width: 100%;
		height: 100vh;
		background: linear-gradient(
			90deg,
			rgba(117, 201, 183, 1) 0%,
			rgba(171, 214, 153, 1) 50%,
			rgba(117, 201, 183, 1) 100%
		);
	}
</style>
